/* =========================
   Config
========================= */
const CART_TIMER_KEY = 'cartTimerExpiresAt';
const DURATION = 5 * 60 * 1000; // 5 minutes
let interval = null;

/* =========================
   Helpers
========================= */
function formatTime(ms) {
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
  const seconds = String(totalSeconds % 60).padStart(2, '0');
  return `${minutes}:${seconds}`;
}

function showOverlay() {
  const overlay = document.getElementById('cart-timer-overlay');
  const overlayTime = document.getElementById('overlay-time');
  if (!overlay || !overlayTime) return;

  overlay.classList.remove('hidden');

  // Auto-dismiss after 2 seconds
  setTimeout(() => {
    overlay.classList.add('hidden');
  }, 2000);
}

/* =========================
   Timer control
========================= */
function startOrResetTimer() {
  const expiresAt = Date.now() + DURATION;
  localStorage.setItem(CART_TIMER_KEY, expiresAt.toString());

  showOverlay();
  startCountdown();
}

function startCountdown() {
  if (interval) clearInterval(interval);

  interval = setInterval(() => {
    const expiresAt = Number(localStorage.getItem(CART_TIMER_KEY));
    if (!expiresAt) return;

    const remaining = expiresAt - Date.now();

    const drawerTimer = document.getElementById('cart-timer');
    const drawerTime = document.getElementById('cart-timer-time');
    const overlay = document.getElementById('cart-timer-overlay');
    const overlayTime = document.getElementById('overlay-time');

    if (remaining <= 0) {
      clearInterval(interval);
      localStorage.removeItem(CART_TIMER_KEY);
      if (drawerTimer) drawerTimer.classList.add('hidden');
      if (overlay) overlay.classList.add('hidden');
      return;
    }

    const formatted = formatTime(remaining);

    if (drawerTimer && drawerTime) {
      drawerTimer.classList.remove('hidden');
      drawerTime.textContent = formatted;
    }

    if (overlay && overlayTime) {
      overlayTime.textContent = formatted;
    }
  }, 1000);
}

/* =========================
   Resume timer on page load
========================= */
function resumeTimerIfActive() {
  const expiresAt = Number(localStorage.getItem(CART_TIMER_KEY));
  if (expiresAt && expiresAt > Date.now()) {
    startCountdown();
  }
}

/* =========================
   Add-to-cart handling
========================= */
async function handleAddToCartForm(e) {
  const form = e.target;

  // Only intercept Shopify add-to-cart forms
  if (!form.action || !form.action.includes('/cart/add')) return;

  e.preventDefault();

  const formData = new FormData(form);

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    });

    const data = await res.json();
    console.log('Item added', data);

    startOrResetTimer();

    // Trigger Shopify cart events
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('cart:updated'));

  } catch (err) {
    console.error('Add to cart failed', err);
  }
}

/* =========================
   Shopify AJAX hooks fallback
========================= */
function attachShopifyCartListeners() {
  document.addEventListener('cart:updated', startOrResetTimer);
  document.addEventListener('ajax:addToCart', startOrResetTimer);
}

/* =========================
   Init
========================= */
document.addEventListener('DOMContentLoaded', () => {
  resumeTimerIfActive();

  // Attach submit listener to document
  document.addEventListener('submit', handleAddToCartForm);

  // Attach fallback Shopify AJAX listeners
  attachShopifyCartListeners();
});
